import { render, staticRenderFns } from "./CircuitosConfig.vue?vue&type=template&id=641ef5e2&scoped=true"
import script from "./CircuitosConfig.vue?vue&type=script&lang=js"
export * from "./CircuitosConfig.vue?vue&type=script&lang=js"
import style0 from "./CircuitosConfig.vue?vue&type=style&index=0&id=641ef5e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ef5e2",
  null
  
)

export default component.exports